import { sumValues } from '../../services/common/formatNew';

export type RegistrationCosts = {
  regionalTaxAmount: number;
  managementAndDeliveryAmount: number;
  malusBeforeTax: number;
  lcvExtraBeforeTax: number;
  weightTax: number;
};

export const calculateRegistrationCosts = (dataSource: QuoteSchema.Schemas.QuoteResponse): RegistrationCosts => {
  const registrationCosts: RegistrationCosts = {
    regionalTaxAmount: 0,
    managementAndDeliveryAmount: 0,
    malusBeforeTax: dataSource?.vehicleData?.co2TaxAmount || 0,
    lcvExtraBeforeTax: 0,
    weightTax: dataSource.vehicleData?.weightTax || 0,
  };

  const deliveryCostComponents =
    (dataSource.financialProduct?.offers?.[0] as any)?.deliveryOptions?.[0]?.deliveryCostComponents ?? [];

  deliveryCostComponents.forEach((component) => {
    const { taxCode, grossAmount = 0 } = component.deliveryCostAmount;
    if (taxCode === 'milesRegionalTax') {
      registrationCosts.regionalTaxAmount = grossAmount ?? 0;
    } else if (taxCode === 'milesManagementTax' || taxCode === 'milesDeliveryFee') {
      registrationCosts.managementAndDeliveryAmount += grossAmount ?? 0;
    } else if (taxCode === 'ParafiscalTax') {
      registrationCosts.lcvExtraBeforeTax = grossAmount ?? 0;
    }
  });

  return registrationCosts;
};

export const getTotalRegistrationCost = (registrationCosts: RegistrationCosts): number => {
  return sumValues(...Object.values(registrationCosts));
};
